import React from "react";
import { MappedEvent } from "@data-types/results";
import { ResultsEventContext } from "@state/context/results";
import ResultsEvent from "./ResultsEvent";
import { tbodyColspanMax } from "./utils";

export default function EventGroup(props: {
	eventGroup: [string, MappedEvent[]];
}) {
	return (
		<>
			<tr className="table--results__body__row table--results__body__row--bordered">
				<td
					className="table--results__body__data table--results__body__data--date"
					colSpan={tbodyColspanMax}
				>
					{props.eventGroup[0]}
				</td>
			</tr>

			{props.eventGroup[1].map((event: MappedEvent) => {
				return (
					<ResultsEventContext.Provider key={event.id} value={event}>
						<ResultsEvent />
					</ResultsEventContext.Provider>
				);
			})}
		</>
	);
}
